import type { CuratedCopy } from "./preview-copy.types";
import { paintbotRoyalCopy } from "./paintbot-royal-copy";
import { generalsCompetitionCopy } from "./generals-competition-copy";
import { paintbotPwCopy } from "./paintbot-pw-copy";
import { sugarscapeCopy } from "./sugarscape-copy";
import { webdiplomacyCopy } from "./webdiplomacy-copy";
import { godsOfTheArenaCopy } from "./gods-of-the-arena-copy";
export const curatedCopy: Readonly<Record<string, CuratedCopy>> = {
  "paintbot-royal": paintbotRoyalCopy,
  "generals-competition": generalsCompetitionCopy,
  "paintbot-pw": paintbotPwCopy,
  "sugarscape-2": sugarscapeCopy,
  webdiplomacy: webdiplomacyCopy,
  "gods-of-the-arena": godsOfTheArenaCopy,
};
